/* eslint-disable no-unused-vars */
import React, { FC, useEffect } from 'react';
import { Box, LinearProgress, makeStyles, Typography } from '@material-ui/core';
import { MobileTable, Page } from 'src/components';
import { Toolbar } from './components/Toolbar';
import { PaymentSummary } from './components/PaymentSummary';
import useCustomerPayment from 'src/hooks/customer-payment/use-customer-payment';
import { useSearchParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { PaymentList } from './components';
import { AmountCell, MobileTablePayments, MOPCell } from './components/table';
import useResolution from 'src/hooks/useResolution';

const useStyles = makeStyles(() => ({
  root: {
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1em',
    minHeight: '92vh'
  }
}));

export const CustomerPaymentView: FC = () => {
  const [searchParams] = useSearchParams();
  const classes = useStyles();
  const {
    customerPaymentComputation,
    customerPaymentList,
    setParams,
    fetchComputation
  } = useCustomerPayment();
  const { xs, md } = useResolution();

  useEffect(() => {
    const filters = Object.fromEntries(searchParams.entries());

    if (isEmpty(filters)) return;

    setParams(filters);
    fetchComputation(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page className={classes.root} title="Customer Payments">
      {customerPaymentComputation?.is_loading ? <LinearProgress /> : null}
      <Typography
        color="textPrimary"
        gutterBottom
        variant="h3"
        style={{ marginBottom: 5 }}
      >
        Customers Payment
      </Typography>

      <Box>
        <Toolbar />
        {!isEmpty(customerPaymentComputation?.computation) ? (
          <>
            <PaymentSummary />
          </>
        ) : null}
      </Box>
      {customerPaymentList.list?.length > 0 ? (
        <Box>
          {xs || md ? (
            <>
              <MobileTablePayments />
            </>
          ) : (
            <PaymentList />
          )}
        </Box>
      ) : null}
    </Page>
  );
};
